import { DataBean } from "../DataBean";

export class NullifyTransport extends DataBean {

    public async nullifyTransportGuide(idTransportGuide: any, transportGuideDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_nullifyTransportGuide_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, idEmployee]);
    }

}